var templates = {
  renderTemplate: function (template, data = {}) {
    let rendered = template;

    // Replace placeholders with actual data
    for (const key in data) {
      const placeholder = `{{${key}}}`;
      rendered = rendered.replace(new RegExp(placeholder, 'g'), data[key]);
    }

    return rendered.trim();
  },
}

export { templates };